"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadElements = void 0;

var _logging = require("./../common/logging");

var _constants = require("./constants");

var _script2 = require("./script");

let elementsPromise;

const loadScript = (url, retryCount) => new Promise((resolve, reject) => {
  let script = (0, _script2.findScript)(url);

  if (!script) {
    script = (0, _script2.injectScript)(url);
  } else {
    if (window.BasisTheoryElements) {
      resolve(window.BasisTheoryElements);
      return;
    }

    if (retryCount > 0) {
      // script already exists in dom
      // remove it to avoid duplicates
      try {
        var _script;

        (_script = script) === null || _script === void 0 ? void 0 : _script.remove();
      } catch (error) {
        (async () => {
          await _logging.logger.log.error(`Error removing script from DOM on retry attempt ${retryCount}`, {
            logType: 'scriptRemovalError',
            logOrigin: 'loadScript',
            retryCount,
            removalError: error
          });
        })();

        reject(new Error(_constants.ELEMENTS_SCRIPT_UNKNOWN_ERROR_MESSAGE));
        return;
      } // re-inject the script


      script = (0, _script2.injectScript)(url);
    }
  } // script load success


  script.addEventListener('load', () => {
    if (window.BasisTheoryElements) {
      resolve(window.BasisTheoryElements);
      return;
    }

    (async () => {
      await _logging.logger.log.error('Elements not found on window on load', {
        logType: 'elementsNotFoundOnWindow',
        logOrigin: 'loadScript',
        retryCount
      });
    })();

    reject(new Error(_constants.ELEMENTS_SCRIPT_LOAD_ERROR_MESSAGE));
    return;
  }); // script error event

  script.addEventListener('error', async event => {
    await _logging.logger.log.error('Elements script onError event', {
      logType: 'elementsScriptOnError',
      logOrigin: 'loadScript',
      retryCount,
      event: {
        message: event === null || event === void 0 ? void 0 : event.message,
        source: event === null || event === void 0 ? void 0 : event.filename,
        lineno: event === null || event === void 0 ? void 0 : event.lineno,
        colno: event === null || event === void 0 ? void 0 : event.colno,
        error: event === null || event === void 0 ? void 0 : event.error,
        target: event === null || event === void 0 ? void 0 : event.target
      }
    }); // retry 1x if first attempt

    if (retryCount === 0) {
      loadScript(url, retryCount + 1).then(resolve).catch(reject);
      return;
    } // second attempt has failed: try fetching the script to inspect the response


    try {
      const response = await fetch(url);
      let responseObject;
      let responseText;

      try {
        responseText = await response.text();
        responseObject = JSON.parse(responseText);
      } catch {
        var _responseText;

        responseObject = (_responseText = responseText) !== null && _responseText !== void 0 ? _responseText : '';
      }

      if (!response.ok) {
        await _logging.logger.log.error(`Second attempt to load elements script failed, fetch failed with status: ${response.status}.`, {
          logType: 'elementsScriptFetchFailure',
          logOrigin: 'loadScript',
          retryCount,
          fetchResult: 'error',
          fetchResponse: responseObject,
          fetchHeaders: response.headers,
          fetchStatusText: response.statusText
        });
        reject(new Error(_constants.ELEMENTS_SCRIPT_FAILED_TO_DELIVER));
        return;
      }

      await _logging.logger.log.error(`Second attempt to load elements script failed, fetch success`, {
        logType: 'elementsScriptFetchFailure',
        logOrigin: 'loadScript',
        retryCount,
        fetchResult: 'success',
        fetchResponse: responseObject,
        fetchHeaders: response.headers,
        fetchStatusText: response.statusText
      });
      reject(new Error(_constants.ELEMENTS_SCRIPT_UNKNOWN_ERROR_MESSAGE));
      return;
    } catch (error) {
      // fetch also failed to make the request; most likely a browser/network error
      await _logging.logger.log.error('Second attempt failed to load elements script failed, fetch network error.', {
        logType: 'elementsScriptFetchError',
        logOrigin: 'loadScript',
        retryCount,
        fetchResult: 'error',
        fetchError: JSON.stringify(error !== null && error !== void 0 ? error : 'Unknown Error')
      });
      reject(new Error(_constants.ELEMENTS_SCRIPT_UNKNOWN_ERROR_MESSAGE));
      return;
    }
  });
});

const loadElements = elementsClientUrl => {
  if (!elementsPromise) {
    elementsPromise = new Promise((resolve, reject) => {
      if (typeof window !== 'object') {
        (async () => {
          await _logging.logger.log.warn(_constants.ELEMENTS_NOM_DOM_ERROR_MESSAGE, {
            logType: 'elementsNonDomError',
            logOrigin: 'loadElements'
          });
          reject(new Error(_constants.ELEMENTS_NOM_DOM_ERROR_MESSAGE));
        })();

        return;
      }

      if (window.BasisTheoryElements) {
        resolve(window.BasisTheoryElements);
        return;
      }

      let url = `https://${"js.basistheory.com"}/web-elements/1.5.0/client/index.js`;

      if (typeof elementsClientUrl !== 'undefined') {
        try {
          const urlObject = new URL(elementsClientUrl);
          url = urlObject.toString().replace(/\/$/u, '');
        } catch {
          (async () => {
            await _logging.logger.log.warn('Invalid format for the given Elements client url.', {
              logType: 'invalidClientUrlError',
              logOrigin: 'loadElements'
            });
          })();

          throw new Error('Invalid format for the given Elements client url.');
        }
      }

      loadScript(url, 0).then(resolve).catch(error => {
        reject(error);
      });
    });
  }

  return elementsPromise;
};

exports.loadElements = loadElements;